import { Send } from 'lucide-react'
import { useTelegramAuthFlow } from '../model/useTelegramAuthFlow'
import { TelegramAuthWaitModal } from './TelegramAuthWaitModal'
import styles from './TelegramAuthButton.module.css'

interface TelegramAuthButtonProps {
  /** URL для редиректа после успешной авторизации */
  redirectTo: string
}

/**
 * Кнопка «Войти через Telegram» для web-сборки.
 * По клику создаёт токен, открывает ссылку на бота и поллит статус.
 * @param redirectTo - URL для редиректа после успеха
 */
export const TelegramAuthButton = ({ redirectTo }: TelegramAuthButtonProps) => {
  const { token, isStarting, error, start, cancel, handleConfirmed, handleExpired } =
    useTelegramAuthFlow({ redirectTo })

  return (
    <>
      <div className={styles.divider}>или</div>

      <button
        type="button"
        className={styles.button}
        disabled={isStarting}
        onClick={start}
      >
        <Send size={20} strokeWidth={2} className={styles.icon} />
        {isStarting ? 'Открываем Telegram…' : 'Войти через Telegram'}
      </button>

      {error && <p className={styles.error}>{error}</p>}

      {token && (
        <TelegramAuthWaitModal
          token={token}
          onConfirmed={handleConfirmed}
          onExpired={handleExpired}
          onCancel={cancel}
        />
      )}
    </>
  )
}
